<!-- BEGIN: Footer-->
<footer class="footer flex w-full border-gray-200 bg-white lg:border-b dark:border-gray-800 dark:bg-gray-900 h-6">

  <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 px-4 py-2 text-xs text-gray-600 dark:text-gray-400">
    <div class="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
      <span class="font-medium">
        Front: Angular V{{environnement?.ngVersion}} • Env {{environnement?.env}}
      </span>
      <span class="text-gray-500 dark:text-gray-500">
        API: Build {{apiParameters?.VGE?.versionAPI}} • Env {{apiParameters?.VGE?.envAPI}}
      </span>
    </div>

    <div class="flex items-center gap-1 text-gray-500 dark:text-gray-500">
      <span>{{environnement.projectName}} © {{year}}</span>
      <span class="mx-1">•</span>
      <span [innerHTML]="environnement.developpedBy" class="text-primary"></span>
    </div>
  </div>

</footer>
<!-- END: Footer-->
